import React, { Component } from 'react'
import { Button, Result } from 'antd'
import F from '../../Functions'

class PageNotFound extends Component {
  render() {
    // return <h1>OOPS PAGE NOT FOUND</h1>;
    return (
      <Result
        status="404"
        title="404"
        subTitle="Sorry, the page you visited does not exist."
        extra={
          F.isProductionHost() ? (
            <Button type="primary">
              <a href="https://bfilesystem.com/">Back Home</a>
            </Button>
          ) : (
            <Button type="primary">
              <a href="http://44.201.240.190:3000/"  //NOSONAR
              >
              Back Home</a>
            </Button>
          )
        }
      />
    )
  }
}

export default PageNotFound



// WEBPACK FOOTER //
// ./src/scenes/Register/404.js